import * as THREE from "three"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
import { FlyControls } from "three/examples/jsm/controls/FlyControls.js"
// Get access to other classes inside the experience class Singleton method
import Experience from "./Experience.js"

export default class Camera{
    constructor(){
        //console.log("Camera Class")
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.time = this.experience.time

        this.setInstance()
        this.setOrbitControls()
    }
    // Set the camera instance
    setInstance(){
        this.instance = new THREE.PerspectiveCamera(
            45,
            this.sizes.width / this.sizes.height,
            0.01, // Near Clip
            1000   // Far Clip
        )

        this.instance.position.set(0, 10, 140)
        this.instance.lookAt(0, 0, 0)
        this.scene.add(this.instance)
    }

    setOrbitControls(){
        if(this.controls){
            this.controls.dispose()
        }
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
        //this.controls.maxTargetRadius = 200
        //this.controls.enableZoom = false
        this.controls.maxDistance = 310
        this.controls.rotateSpeed = 0.18
        // Listen to keyboard events
        this.controls.listenToKeyEvents(window)
    }

    // For future capabilities
    setFlyControls(){
        if(this.controls){
            this.controls.dispose()
        }
        this.controls = new FlyControls(this.instance, this.canvas)
        this.controls.movementSpeed = 4
        //this.controls.domElement = this.canvas
        this.controls.rollSpeed = Math.PI / 24
        this.controls.dragToLook = true
        //this.controls.listenToKeyEvents(window)

    }

    resize(){
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update(){
        if(this.controls instanceof OrbitControls){
            this.controls.update()
        }
        else if (this.controls instanceof FlyControls){
            this.controls.update(this.time.delta / 1000) // convert time class milliseconds to seconds
        }

        //this.controls.update()
    }
}